const steps = [
  {
    number: '01',
    icon: 'ri-chat-3-line',
    title: 'Modelini Anlat',
    desc:
      'WhatsApp üzerinden bize yazın. Hayal ettiğiniz tasarımı, rengi, materyali ve özel detayları paylaşın. Referans görseller gönderebilirsiniz.',
  },
  {
    number: '02',
    icon: 'ri-pencil-ruler-2-line',
    title: 'Tasarım Hazırlanır',
    desc:
      'Uzman tasarımcılarımız, beklentilerinize uygun taslakları hazırlar. Onay verene kadar revizyon yapılır. Süreci birlikte yönetiriz.',
  },
  {
    number: '03',
    icon: 'ri-sparkling-2-line',
    title: 'Sana Özel Üretilir',
    desc:
      'Onaylanan tasarım, usta goldsmith\'lerimiz tarafından özenle üretilir ve adresinize teslim edilir.',
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="w-full bg-luxury-dark py-24 md:py-36 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="reveal">
            <span className="font-sans text-gold text-xs tracking-luxury uppercase">
              Süreç
            </span>
          </div>
          <h2 className="reveal reveal-delay-1 font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light mt-5 leading-tight">
            Nasıl Çalışır?
          </h2>
          <p className="reveal reveal-delay-2 font-sans text-white/50 text-sm mt-5 max-w-md mx-auto leading-relaxed">
            Üç basit adımda, hayalinizdeki takı gerçek olur.
          </p>
          <div className="reveal reveal-delay-3 gold-line w-24 mx-auto mt-8" />
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative">
          {/* Connector line – desktop only */}
          <div className="hidden md:block absolute top-[52px] left-[calc(16.66%+2rem)] right-[calc(16.66%+2rem)] h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />

          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`reveal reveal-delay-${i + 1} group relative flex flex-col items-center text-center`}
            >
              {/* Step circle */}
              <div className="relative mb-8">
                <div className="w-[104px] h-[104px] flex items-center justify-center rounded-full luxury-border bg-luxury-card group-hover:border-gold/60 transition-all duration-500">
                  <i className={`${step.icon} text-gold text-3xl`} />
                </div>
                <span className="absolute -top-3 -right-2 font-sans text-gold/30 text-xs tracking-luxury font-medium">
                  {step.number}
                </span>
              </div>

              {/* Content */}
              <h3 className="font-serif text-2xl text-white font-light mb-4">{step.title}</h3>
              <div className="gold-line w-10 mb-4" />
              <p className="font-sans text-white/50 text-sm leading-loose max-w-xs">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
